import { useMemo } from 'react';
import { useSnapshot } from 'valtio';
import { tasksState } from '../state';
import { ITask } from '../types';

function useTasks() {
  const { tasks } = useSnapshot(tasksState);

  const taskArray = useMemo(() => Object.values(tasks) as ITask[], [tasks]);

  return {
    tasks: taskArray,
    taskById: tasks,
  };
}

export default useTasks;
